
export default function WorkoutSettings(){
  return <div className="rounded-xl border bg-white p-4">운동 설정 테이블 자리</div>;
}
